import React from 'react';
import PropTypes from 'prop-types';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { useLocaleContext } from '../../context/LocaleContext';
import { ViewOrderHeader } from '../dashboardCommon';
import 'react-datepicker/dist/react-datepicker.css';

const fieldMapping = {
  orderId: 'orderId',
  businessName: 'legalBusinessNameFM',
  products: 'productSelectionFM',
  status: 'status'
};

const ViewOrderHeaderFM = ({ orderData }) => {
  const locale = useLocaleContext();
  const {
    ORDERS: { orderId, businessName, statusText, productsLabel },
    DEFECT_MANAGEMENT: { STATUS }
  } = locale === 'en-US' ? EN : FR;

  const labels = {
    orderIdLabel: orderId,
    businessNameLabel: businessName,
    productsLabel,
    statusLabel: STATUS,
    statusTextMap: statusText
  };

  return (
    <ViewOrderHeader
      orderData={orderData}
      labels={labels}
      fieldMapping={fieldMapping}
    />
  );
};

ViewOrderHeaderFM.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default ViewOrderHeaderFM;
